// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KS58","type":"styles_type__3174m","choices":"styles_choices__Xk-SX"};